import { useVoucherStore, VoucherClass } from '@finn/ua-vehicle';
import {
  clearClientCookie,
  CookieKeys,
  getClientCookie,
  traceabilityHeadersBrowser,
  useCurrentLocale,
} from '@finn/ui-utils';
import queryString from 'query-string';
import { useEffect, useState } from 'react';

import { getVoucherByHash } from '~/services/voucher';

const VoucherParam = 'VoucherCode';

export const useProcessVoucherParam = () => {
  const [refreshHash, setRefreshHash] = useState<string | null>(null);
  const setVoucherData = useVoucherStore(
    (state) => state.setReferralVoucherData
  );
  const clearReferralVoucher = useVoucherStore(
    (state) => state.clearReferralVoucher
  );
  const referralVoucherData = useVoucherStore(
    (state) => state.referralVoucherData
  );
  const { locale } = useCurrentLocale();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const voucherInCookie = getClientCookie(CookieKeys.VOUCHER_CODE);
    const voucherHash =
      urlParams.get(VoucherParam) || voucherInCookie || refreshHash;

    if (voucherHash) {
      getVoucherByHash(voucherHash, locale, traceabilityHeadersBrowser())
        .then((data) => {
          if (data.status === 200 && data.is_valid) {
            setVoucherData(data, voucherHash);
            // CUG_ID and closed_user_group are mutually exclusive
            if (data.class === VoucherClass.closed_user_group) {
              clearClientCookie(CookieKeys.CLOSED_USER_GROUP_ID);
            }
          } else {
            clearReferralVoucher();
          }
        })
        .catch(() => {
          clearReferralVoucher();
        });
      setRefreshHash(null);
    }
    // run once or on refreshHash change
  }, [refreshHash]);

  // refresh voucher if image url is expired
  useEffect(() => {
    const imgUrl = referralVoucherData?.image?.url;
    const params = queryString.parse(imgUrl?.split('?')[1] || '');
    const savedDateISO8601 = params['X-Amz-Date'] as string;
    const expiresInSeconds = params['X-Amz-Expires'] as string;

    if (savedDateISO8601 && expiresInSeconds) {
      const savedDateFormatted = savedDateISO8601.replace(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/,
        '$1-$2-$3T$4:$5:$6Z'
      );
      const savedDate = new Date(savedDateFormatted);
      const expiresAt = new Date(
        savedDate.getTime() + Number(expiresInSeconds) * 1000
      );
      if (expiresAt < new Date()) {
        const voucherHashInCookie = getClientCookie(
          CookieKeys.REFERRAL_VOUCHER_HASH
        );
        setRefreshHash(voucherHashInCookie || null);
      }
    }
  }, [referralVoucherData]);
};
